// extracted by mini-css-extract-plugin
module.exports = {"layout":"main_layout__1EWd8"};